import { render, staticRenderFns } from "./UserRoleEdit.vue?vue&type=template&id=216ac914&"
import script from "./UserRoleEdit.vue?vue&type=script&lang=ts&"
export * from "./UserRoleEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports